import styles from "./ZoomOutControl.module.scss";
import cx from "classnames";

export class ZoomOutControl implements mapboxgl.IControl {
  private _map: any;
  private readonly _container: HTMLDivElement | null = null;
  private readonly _button: HTMLDivElement | null = null;

  private readonly _onClick: () => void;
  private _title: string;

  constructor(onClick: () => void, title: string) {
    this._onClick = onClick;
    this._title = title;

    if (typeof window !== "undefined") {
      this._container = document.createElement("div");
      this._container.className = cx(styles.container, "mapboxgl-ctrl");

      this._button = this._createButton();

      this._container.append(this._button);
    }
  }

  onAdd(map: mapboxgl.Map) {
    this._map = map;

    this._button?.addEventListener("click", this._onClickHandler.bind(this));

    return this._container as HTMLElement;
  }

  onRemove() {
    this._button?.removeEventListener("click", this._onClickHandler.bind(this));

    this._container?.parentNode?.removeChild(this._container);
    this._map = undefined;
  }

  private _onClickHandler() {
    this._onClick();
    this.hideButton();
  }

  private _createButton() {
    const btn = document.createElement("div");
    btn.className = styles.button;

    btn.textContent = this._title;

    return btn;
  }

  setTitle(title: string) {
    this._title = title;

    if (this._button) {
      this._button.textContent = this._title;
    }
  }

  public showButton() {
    this._button?.classList.remove("hidden");
  }

  public hideButton() {
    this._button?.classList.add("hidden");
  }
}
